// ---------------------------------------------------------------------------
// src/modules/lead/pages/CaseList.js
// ---------------------------------------------------------------------------
import React, { useEffect, useState } from "react"
import { Card, Badge } from "react-bootstrap"
import { Link } from "react-router-dom"
import Layout from "../../../layout/default"
import DataTable from "../../../components/DataTable/DataTable.js"
import caseService from "../services/caseService.js"

/* -------------------------------------------------------------------------- */
/*                              COMPONENTE MAIN                               */
/* -------------------------------------------------------------------------- */

const pageSize = 10          

const CaseList = () => {
  /* ------------------------------ estados ------------------------------- */
  const [caseData, setCaseData] = useState([])
  const [loading,  setLoading]  = useState(false)
  const [page,     setPage]     = useState(1)
  const [count,    setCount]    = useState(0)

  /* ------------------------------- fetch -------------------------------- */
  const fetchCaseList = async (pageNumber = 1) => {
    setLoading(true)
    try {
      const { results, count } = await caseService.getCaseListPaginate(
        pageNumber,
        pageSize
      )
      const mapped = results.map(r => ({
        ...r,
        lead_fullname: r.lead ? `${r.lead.name} ${r.lead.last_name}` : ""
      }))

      setCaseData(mapped)
      setCount(count)
      setPage(pageNumber)
    } catch (err) {
      console.error("Error al obtener casos:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchCaseList(1) }, [])

  /* ------------------------ columnas de la tabla ------------------------ */
  const listColumns = [
    { name:"ID",          selector:r=>r.id,           sortable:true, center:true,
      minWidth:"60px",  headerStyle:{textAlign:"center"}, style:{textAlign:"center"} },
    { name:"Caso #",      selector:r=>r.case_number,  sortable:true, center:true,
      minWidth:"120px", headerStyle:{textAlign:"center"}, style:{textAlign:"center"} },
    { name:"Estado",      selector:r=>r.state_detail?.state||"—",
      sortable:true, center:true, minWidth:"120px",
      headerStyle:{textAlign:"center"}, style:{textAlign:"center"} },
    { name:"Cliente",
      selector:r=>r.lead_fullname,                    
      sortable:true, center:true, minWidth:"160px",
      headerStyle:{textAlign:"center"}, style:{textAlign:"center"} },
    { name:<div style={{width:"100%",textAlign:"center"}}>Abogado</div>,
      selector:r=>r.lawyer??"",
      cell:r=>(
        <div style={{display:"flex",justifyContent:"center",width:"100%"}}>
          {r.lawyer ? (
            <Badge bg="info">
              <Link to={`/lawyer/${r.lawyer}`}>
                <span style={{color:"white"}}>{r.lawyer}</span>
              </Link>
            </Badge>
          ) : "Sin asignar"}
        </div>
      ),
      sortable:true, center:true },
  ]

  /* ------------------------------ render ------------------------------- */
  return (
    <Layout title="Casos" content="container" loading={loading}>
      <Card>
        <DataTable
          tableClassName="data-table-head-light table-responsive"
          data={caseData}
          columns={listColumns}
          backEndPagination
          fetchPaginatedData={fetchCaseList}
          pageCount={count}
          currentPaginationPage={page}
          searchByList={["lead_fullname","case_number"]}
        />
      </Card>
    </Layout>
  )
}

export default CaseList
